import { createSlice } from "@reduxjs/toolkit";
import { IAssessmentRole, IClientUserRole } from "@/shared/services/roles/roles-http.service";

export interface IRolesStore {
  isLoaded: boolean;
  data: {
    assessmentRoles: IAssessmentRole[];
    clientRoles: IClientUserRole[];
  };
}

export const slice = createSlice({
  name: "roles",
  initialState: {
    isLoaded: false,
    data: { assessmentRoles: [], clientRoles: [] },
  } as IRolesStore,
  reducers: {
    addRoles: (state, action) => {
      const { isLoading, roles } = action.payload;

      return {
        ...state,
        isLoaded: !isLoading,
        data: roles,
      };
    },
  },
});

export const { addRoles } = slice.actions;

export const selectRoles = (state: { roles: IRolesStore }) => (state.roles.isLoaded ? state.roles.data : []);

export const selectClientRoles = (state: { roles: IRolesStore }) =>
  state.roles.isLoaded ? state.roles.data.clientRoles : [];

export const selectAssessmentRoles = (state: { roles: IRolesStore }) =>
  state.roles.isLoaded ? state.roles.data.assessmentRoles : [];

export default slice.reducer;
